import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { MainConfig } from '../main-config';

@Injectable()
export class UploadService {
  private urlUpload: string = '';
  private authorization: string = '';

  constructor(private mainConfig: MainConfig) {
    this.urlUpload = this.mainConfig.apiUrl + '/upload-file';

    if (localStorage.getItem(this.mainConfig.authTokenName) !== null) {
      this.authorization = 'Bearer ' + localStorage.getItem(this.mainConfig.authTokenName);
    }    
  }

  upload(file: File): Observable<any> {  
    return Observable.create(observer => {
      let formData: FormData = new FormData();
      let xhr: XMLHttpRequest = new XMLHttpRequest();

      formData.append('files', file, file.name); 

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }         
        }
      };

      xhr.open('POST', this.urlUpload);
      xhr.setRequestHeader('Authorization', this.authorization);
      xhr.send(formData);
    });
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/services/upload.service.ts